import { FILTER } from '@fiverr-private/listing_lib';
import { getFilterById } from '../util';

export const getPersonalAssistantFilter = (filters) => {
    const filter = getFilterById(filters, FILTER.PERSONAL_ASSISTANT.ID);

    if (!filter) return null;

    return { ...filter, selectedValue: ['true'] };
};
